var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApplicationContext } from "../../../ApplicationContext";
import React, { createRef } from "react";
import { injectIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import { observer } from "mobx-react";
import { getEnumKeys } from "../../../utils/enumUtils";
import { ReportIntervalType } from "../../../data/ReportIntervalType";
import BasicFormGroup from "../../components/ui/BasicFormGroup/BasicFormGroup";
var ReportInterval = /** @class */ (function (_super) {
    __extends(ReportInterval, _super);
    /**
     *
     */
    function ReportInterval(props) {
        var _this = _super.call(this, props) || this;
        _this.selectRef = createRef();
        _this.amountRef = createRef();
        _this.state = { amount: 1 };
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    ReportInterval.prototype.componentDidMount = function () {
        this.updateReportParameter();
    };
    ReportInterval.prototype.render = function () {
        var _a = this.props, intl = _a.intl, reportParameterInfoModel = _a.reportParameterInfoModel;
        var amount = this.state.amount;
        return React.createElement(Row, null,
            React.createElement(Col, { sm: 6 },
                React.createElement(BasicFormGroup, { htmlFor: 'amount', label: intl.formatMessage({ id: 'reports.settings.form.interval.amount' }) },
                    React.createElement("input", { ref: this.amountRef, type: "number", id: "amount", name: "amount", className: "form-control", min: 1, max: 400, step: "1", value: amount, onChange: this.onInputChange }))),
            React.createElement(Col, { sm: 6 },
                React.createElement(BasicFormGroup, { htmlFor: reportParameterInfoModel.parameterId, label: intl.formatMessage({ id: 'reports.settings.form.interval.timeunit' }) },
                    React.createElement("select", { id: reportParameterInfoModel.parameterId, ref: this.selectRef, name: reportParameterInfoModel.parameterId, className: "form-control w-100", onChange: this.onInputChange }, getEnumKeys(ReportIntervalType).map(function (key, index) {
                        return React.createElement("option", { key: 'opt-' + key + '-' + index, value: key }, intl.formatMessage({ id: 'reports.settings.form.interval.' + key }));
                    })))));
    };
    ReportInterval.prototype.onInputChange = function (event) {
        if (event.target.name === 'amount') {
            var limitedValue = Math.max(event.target.min, Math.min(event.target.max, event.target.value));
            this.setState({ amount: limitedValue });
        }
        this.updateReportParameter();
    };
    ReportInterval.prototype.updateReportParameter = function () {
        var reportParameterModel = this.props.reportParameterModel;
        var amount = this.amountRef.current.value;
        var unit = this.selectRef.current.value.toLowerCase();
        reportParameterModel.value = amount + ' ' + unit + (amount > 1 ? 's' : '');
    };
    ReportInterval = __decorate([
        observer
    ], ReportInterval);
    return ReportInterval;
}(React.Component));
ReportInterval.contextType = ApplicationContext;
export default injectIntl(ReportInterval);
